module.exports = __webpack_public_path__ + "img/adwords_graphic.ae4ea37c.svg";